var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_vm._v(" "),_c('div',{class:{ wrap: _vm.wrap }},[_c('BreadCrumb',{attrs:{"isShow":_vm.breadcrumb}}),_vm._v(" "),_c('router-view')],1),_vm._v(" "),_c('AnchorComp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }